/** Goal Types */
export const GET_GOALS = 'GET_GOALS';
export const GET_GOALS_SUCCESS = 'GET_GOALS_SUCCESS';

export const GET_GOALS_FOR_SESSION = 'GET_GOALS_FOR_SESSION';
export const GET_GOALS_FOR_SESSION_SUCCESS = 'GET_GOALS_FOR_SESSION_SUCCESS';

export const GET_SIMPLE_GOALS = 'GET_SIMPLE_GOALS';
export const GET_SIMPLE_GOALS_SUCCESS = 'GET_SIMPLE_GOALS_SUCCESS';

export const GET_GOAL_BY_ID = 'GET_GOAL_BY_ID';
export const GET_GOAL_BY_ID_SUCCESS = 'GET_GOAL_BY_ID_SUCCESS';
export const GET_SECTION_TYPES = 'GET_SECTION_TYPES';
export const GET_SECTION_TYPES_SUCCESS = 'GET_SECTION_TYPES_SUCCESS';
export const CREATE_SECTION_TYPE = 'CREATE_SECTION_TYPE';
export const EDIT_SECTION_TYPE = 'EDIT_SECTION_TYPE';

export const CREATE_GOAL = 'CREATE_GOAL';
export const EDIT_GOAL = 'EDIT_GOAL';
export const EDIT_GOAL_STATUS = 'EDIT_GOAL_STATUS';
export const UPSERT_SECTION_DESCRIPTION_BLOCK = 'UPSERT_SECTION_DESCRIPTION_BLOCK';
export const DELETE_SECTION_DESCRIPTION_BLOCK = 'DELETE_SECTION_DESCRIPTION_BLOCK';
export const REORDER_SECTION_DESCRIPTION_BLOCKS = 'REORDER_SECTION_DESCRIPTION_BLOCKS';
export const DELETE_GOAL = 'DELETE_GOAL';
export const RESTORE_GOAL = 'RESTORE_GOAL';
export const CLONE_GOAL = 'CLONE_GOAL';
export const GET_GOAL_SESSIONS = 'GET_GOAL_SESSIONS';
export const GET_GOAL_SESSIONS_SUCCESS = 'GET_GOAL_SESSIONS_SUCCESS';
export const GET_GOAL_GRAPH = 'GET_GOAL_GRAPH';
export const GET_GOAL_GRAPH_SUCCESS = 'GET_GOAL_GRAPH_SUCCESS';
export const GET_GOAL_TRIAL_DATA = 'GET_GOAL_TRIAL_DATA';
export const GET_GOAL_TRIAL_DATA_SUCCESS = 'GET_GOAL_TRIAL_DATA_SUCCESS';

export const CHOOSE_GOALS_FROM_LIBRARY = 'CHOOSE_GOALS_FROM_LIBRARY';
export const CHOOSE_TARGETS_FROM_LIBRARY = 'CHOOSE_TARGETS_FROM_LIBRARY';
export const CHOOSE_OPTIONS_FROM_LIBRARY = 'CHOOSE_OPTIONS_FROM_LIBRARY';
/** End */

/** Targets */
export const CREATE_TARGET = 'CREATE_TARGET';
export const EDIT_TARGET = 'EDIT_TARGET';
export const EDIT_TARGET_TRANSITION_DATE = 'EDIT_TARGET_TRANSITION_DATE';
export const REORDER_TARGET = 'REORDER_TARGET';
export const GET_TARGET_CHART_DATA = 'GET_TARGET_CHART_DATA';
export const GET_TARGET_CHART_DATA_SUCCESS = 'GET_TARGET_CHART_DATA_SUCCESS';

/** End */

/** Options */
export const CREATE_OPTION = 'CREATE_OPTION';
export const EDIT_OPTION = 'EDIT_OPTION';
export const DELETE_OPTION = 'DELETE_OPTION';
export const RESTORE_OPTION = 'RESTORE_OPTION';
export const REORDER_OPTION = 'REORDER_OPTION';

/** End */

/** Mastery */
export const CHANGE_TARGET_MASTERY = 'CHANGE_TARGET_MASTERY';
export const CHANGE_GOAL_MASTERY = 'CHANGE_GOAL_MASTERY';
export const CHANGE_SINGLE_TARGET_MASTERY = 'CHANGE_SINGLE_TARGET_MASTERY';
export const SINGLE_TARGET_MASTERY_FOLLOW_GOAL = 'SINGLE_TARGET_MASTERY_FOLLOW_GOAL';
export const REMOVE_SINGLE_TARGET_MASTERY = 'REMOVE_SINGLE_TARGET_MASTERY';

/** Baseline -> Teaching criteria */
export const CHANGE_BASELINE_CRITERIA = 'CHANGE_BASELINE_CRITERIA';
export const CHANGE_SINGLE_TARGET_BASELINE_CRITERIA = 'CHANGE_SINGLE_TARGET_BASELINE_CRITERIA';
export const SINGLE_TARGET_BASELINE_FOLLOW_GOAL = 'SINGLE_TARGET_BASELINE_FOLLOW_GOAL';
export const REMOVE_SINGLE_TARGET_BASELINE_CRITERIA = 'REMOVE_SINGLE_TARGET_BASELINE_CRITERIA';
export const CHANGE_SINGLE_TARGET_MAINTENANCE = 'CHANGE_SINGLE_TARGET_MAINTENANCE';
export const ADD_SINGLE_TARGET_MAINTENANCE_STEP = 'ADD_SINGLE_TARGET_MAINTENANCE_STEP';
export const EDIT_SINGLE_TARGET_MAINTENANCE_STEP = 'EDIT_SINGLE_TARGET_MAINTENANCE_STEP';
export const SINGLE_TARGET_FOLLOW_GOAL_CONFIG = 'SINGLE_TARGET_FOLLOW_GOAL_CONFIG';
export const DELETE_SINGLE_TARGET_MAINTENANCE_STEP = 'DELETE_SINGLE_TARGET_MAINTENANCE_STEP';
export const CHANGE_MAINTENANCE_STEP = 'CHANGE_MAINTENANCE_STEP';

/** End */

/** Target Maintenance */
export const CHANGE_TARGET_MAINTENANCE = 'CHANGE_TARGET_MAINTENANCE';
export const ADD_TARGET_MAINTENANCE_STEP = 'ADD_TARGET_MAINTENANCE_STEP';
export const EDIT_TARGET_MAINTENANCE_STEP = 'EDIT_TARGET_MAINTENANCE_STEP';
export const DELETE_TARGET_MAINTENANCE_STEP = 'DELETE_TARGET_MAINTENANCE_STEP';

/** End */

/** Goal Clinical Data */
export const GET_GOAL_CLINICAL_DATA = 'GET_GOAL_CLINICAL_DATA';
export const GET_GOAL_CLINICAL_DATA_SUCCESS = 'GET_GOAL_CLINICAL_DATA_SUCCESS';
export const GET_GOAL_TARGET_CLINICAL_DATA = 'GET_GOAL_TARGET_CLINICAL_DATA';
export const GET_GOAL_TARGET_CLINICAL_DATA_SUCCESS = 'GET_GOAL_TARGET_CLINICAL_DATA_SUCCESS';
export const GET_GOAL_CLINICAL_DEFAULT_VALUES = 'GET_GOAL_CLINICAL_DEFAULT_VALUES';
export const GET_GOAL_CLINICAL_DEFAULT_VALUES_SUCCESS = 'GET_GOAL_CLINICAL_DEFAULT_VALUES_SUCCESS';
/** End */
